import { useFetchCompanySummary } from './useFetchCompanySummary';
import { getInfoFields, getSnowflakeScoresAverage } from './utils';

type Props = {
  canonicalUrl: string;
};

export const useCompanySummary = ({ canonicalUrl }: Props) => {
  const { data, status } = useFetchCompanySummary(
    { canonicalUrl },
    {
      enabled: Boolean(canonicalUrl),
    }
  );

  const { Company: company } = data || {};

  const snowflakeScoresAverage = getSnowflakeScoresAverage(company?.score);

  const {
    name,
    shortName,
    yearFunded,
    url,
    exchangeSymbol,
    tickerSymbol,
    uniqueSymbol,
    address,
    address2,
    city,
    state,
    country,
  } = getInfoFields(company?.data.info);

  return {
    companyId: company?.id,
    canonicalURL: company?.canonicalURL,
    isSearchable: company?.isSearchable,
    classificationStatus: company?.classificationStatus,
    dateGenerated: company?.dateGenerated,
    media: company?.media,
    snowflakeScores: company?.score,
    isFund: company?.analysisMisc?.isFund,
    preferredMultiple: company?.analysisValue?.preferredMultiple,
    hasLogo: company?.info?.hasLogo,
    snowflakeScoresAverage,
    name,
    shortName,
    yearFunded,
    url,
    exchangeSymbol,
    tickerSymbol,
    uniqueSymbol,
    address,
    address2,
    city,
    state,
    country,
    status,
  };
};
